import { Card, Col, Row, Tag, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QUESTS, QUEST_IDS, mapUrl, pagePath } from '@app/lib/site';
import { track } from '@app/lib/track';
import { useLang } from '@app/lib/useLang';
import { QUEST_MAPS } from '@app/lib/questMap';
import { QuestGallery } from '../QuestGallery';
import { InteractiveMap } from '../InteractiveMap';
import styles from './style.module.css';

const { Title, Paragraph } = Typography;

interface CardText {
  title: string;
  description: string;
  coordinates: string;
  /** Покрытие маршрута: брусчатка, лестницы. */
  terrain?: string;
}

export const RoutesCards: React.FC = () => {
  const { t } = useTranslation();
  const lang = useLang();
  const cards = t('routes.cards', { returnObjects: true }) as Record<string, CardText>;

  return (
    <div className={styles.container}>
      <Title level={2} className={styles.heading}>
        {t('routes.heading')}
      </Title>
      <div className={styles.cardContainer}>
        <Row gutter={[24, 24]} justify="center">
          {(['olhao', 'faro', 'alte'] as const).filter((id) => QUEST_IDS.includes(id)).map((id) => {
            const { title, description, coordinates, terrain } = cards[id];
            const q = QUESTS[id];
            const details = pagePath(id, lang);
            return (
              <Col key={id} xs={24} sm={24} md={12} lg={8} className={styles.col}>
                <Card
                  className={styles.card}
                  cover={
                    <div className={styles.coverWrapper}>
                      <QuestGallery
                        quest={id}
                        alt={title}
                        w={600}
                        h={400}
                        mapNode={QUEST_MAPS[id] ? <InteractiveMap quest={id} alt={title} /> : undefined}
                      />
                      <Tag className={styles.ageTag}>{q.age}</Tag>
                    </div>
                  }
                >
                  <Title level={4} className={styles.cardTitle}>
                    <a href={details}>{title}</a>
                  </Title>
                  <Paragraph className={styles.cardDesc}>{description}</Paragraph>
                  <Paragraph className={styles.cardDesc}>
                    <a href={mapUrl(id)} target="_blank" rel="noopener noreferrer">
                      {coordinates}
                    </a>
                  </Paragraph>
                  {terrain && <Paragraph className={`${styles.cardDesc} ${styles.terrain}`}>{terrain}</Paragraph>}
                  <div className={styles.buttonWrapper}>
                    <a
                      className={styles.button}
                      href={details}
                      onClick={() => track('route_cta_click', { route_id: id, language: lang, cta_location: 'home_card' })}
                    >
                      {t('routes.button')}
                    </a>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default RoutesCards;
